import "./profile.css";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeEmail,
  changeEmailCleanup,
} from "../../../Store/actions/changeEmail.js/index.js";
import { Button } from "../../../Components/ui/Button";
import InputField from "../../../Components/ui/form/Input";
import { useAppSelector } from "../../../hooks";
import { selectLoggedInUser } from "../../../Store/actions/getMe";

function EditProfile() {
  const dispatch = useDispatch();
  const userState = useAppSelector(selectLoggedInUser);
  const changeEmailState = useAppSelector((state) => state.changeEmail);

  const [newEmail, setNewEmail] = useState("");

  const [msg, setMsg] = useState("");

  const submitEmail = (e) => {
    e.preventDefault();

    const data = { newEmail };

    setMsg("");
    dispatch(changeEmail(data));

    setNewEmail("");
  };

  useEffect(() => {
    if (changeEmailState.isSuccessful) {
      setMsg("Check your email to continue");
      dispatch(changeEmailCleanup());
    } else if (changeEmailState.error) {
      setMsg("An error occured. try again");
      dispatch(changeEmailCleanup());
    }
  }, [changeEmailState]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="editProfileWrapper mx-auto">
      <form
        onSubmit={submitEmail}
        className="editProfileInner"
        style={{ borderBottom: "1px solid rgba(0,0,0,0.2)" }}
      >
        <h4>Change Email</h4>

        <InputField
          label="Old Email"
          type="email"
          name="oldEmail"
          defaultValue={userState?.data?.user?.email}
          placeholder="Enter Old Email"
          // value={form?.oldEmail}
          readOnly
          disabled
          isRequired
        />

        <InputField
          label="New Email"
          type="email"
          name="newEmail"
          placeholder="Enter New Email"
          // value={form?.newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          isRequired
        />

        {msg && (
          <div>
            <p>{msg}</p>
          </div>
        )}

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="btn--edit-profile"
            loading={changeEmailState?.isLoading}
            type="submit"
          >
            Change Email
          </Button>
        </div>
      </form>
    </div>
  );
}

export default EditProfile;
